const API_BASE = process.env.REACT_APP_BACKEND_URL + '/api';

class ApiService {
  async post(endpoint, data) {
    try {
      const response = await fetch(`${API_BASE}${endpoint}`, {
        method: 'POST',
        headers: { 
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data)
      });
      
      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.detail || `HTTP error! status: ${response.status}`);
      }
      
      return await response.json();
    } catch (error) {
      console.error(`API POST ${endpoint} error:`, error);
      throw error;
    }
  }
  
  async get(endpoint) {
    try {
      const response = await fetch(`${API_BASE}${endpoint}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        }
      });
      
      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.detail || `HTTP error! status: ${response.status}`);
      }
      
      return await response.json();
    } catch (error) {
      console.error(`API GET ${endpoint} error:`, error);
      throw error;
    }
  }
}

const apiService = new ApiService();

// Specific API functions
export const contactAPI = {
  createInquiry: (data) => apiService.post('/contact-inquiries', data),
  getInquiries: () => apiService.get('/contact-inquiries')
};

export const servicesAPI = {
  getAll: () => apiService.get('/services'),
  getById: (id) => apiService.get(`/services/${id}`)
};

export const serviceModelsAPI = {
  getAll: () => apiService.get('/service-models')
};

export const referencesAPI = {
  getAll: () => apiService.get('/references'),
  getFeatured: () => apiService.get('/references/featured')
};

export const jobsAPI = {
  getOpenings: () => apiService.get('/job-openings'),
  getOpening: (id) => apiService.get(`/job-openings/${id}`),
  createApplication: (data) => apiService.post('/job-applications', data),
  getApplications: () => apiService.get('/job-applications')
};

export const cyberAPI = {
  createAssessment: (data) => apiService.post('/cyber-risk-assessments', data),
  getAssessments: () => apiService.get('/cyber-risk-assessments')
};

// Statistics API
export const statsAPI = {
  getStatistics: () => apiService.get('/statistics')
};

export default apiService;